'use client'

// src/components/hero/Countdown.tsx
import { useId } from "react";
import { twMerge } from "tailwind-merge";
import { useCountDown } from "@wbk/hooks";
import { useTranslation } from "@wbk/config";
import { Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var NOW_SECONDS = (/* @__PURE__ */ new Date()).getTime() / 1e3;
var HeroCountdown = ({ finishDate, mini = false, className }) => {
  const { t } = useTranslation("contentful_common");
  const id = useId();
  const { timer, isTimeUp } = useCountDown({
    id,
    initialSeconds: new Date(finishDate).getTime() / 1e3 - NOW_SECONDS
  });
  if (isTimeUp) {
    return null;
  }
  if (mini) {
    return `${timer.days}D:${timer.hours}H:${timer.minutes}M:${timer.seconds}S`;
  }
  return /* @__PURE__ */ jsxs("div", { className: twMerge("mx-auto flex max-w-sm justify-center gap-4 text-center", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "heading-M", as: "h3", children: timer.days }),
      /* @__PURE__ */ jsx(Typography, { variant: "label-S", color: "text-secondary", as: "h3", children: t("contentful_common:timer.days") })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "heading-M", as: "h3", children: timer.hours }),
      /* @__PURE__ */ jsx(Typography, { variant: "label-S", color: "text-secondary", as: "h3", children: t("contentful_common:timer.hours") })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "heading-M", as: "h3", children: timer.minutes }),
      /* @__PURE__ */ jsx(Typography, { variant: "label-S", color: "text-secondary", as: "h3", children: t("contentful_common:timer.minutes") })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "bg-text/10 grow rounded-md px-4 py-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "heading-M", as: "h3", children: timer.seconds }),
      /* @__PURE__ */ jsx(Typography, { variant: "label-S", color: "text-secondary", as: "h3", children: t("contentful_common:timer.seconds") })
    ] })
  ] });
};
var Countdown_default = HeroCountdown;

export {
  Countdown_default
};
//# sourceMappingURL=chunk-CGCU6FO5.mjs.map